import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import "./Css/View.css";
import profile from "./Images/Ellipse 24 (9).png";
import API_BASE from "../config/api";

const StudentView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);
  const handleEditClick = (index) => {
    navigate(`/dashboard/studentedit/${id}`);
  };

  const API_BASE_URL = `${API_BASE}`;

  useEffect(() => {
    if (!id) return;

    const fetchStudent = async () => {
      try {
        const studentUserId = sessionStorage.getItem("userId"); // or decode JWT
        const instituteId = location.state?.instituteId;

        if (!instituteId) {
          console.error("InstituteId missing in navigation state");
          return;
        }
        const res = await axios.get(
          `${API_BASE_URL}/api/instituteadmin/students/${id}`,
          {
            params: {
              studentUserId,
              instituteId
            },
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
            }
          }
        );
        setStudent(res.data);
        console.log(res.data, 'data')
      } catch (err) {
        console.error("Failed to fetch student", err);
      } finally {
        setLoading(false);
      }
    };

    fetchStudent();
  }, [id]);

  const formatDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!student) {
    return <div>Student not found</div>;
  }


  return (
    <div className="student-page">
      {/* Header */}
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}>
          संस्था व्यवस्थापन &gt;&gt; तपशील&gt;&gt; विद्यार्थी माहिती&gt;&gt; <span>विद्यार्थी तपशील</span>
        </h3>
        <button className="edit-btn" onClick={() => handleEditClick()} >एडिट करा</button>
      </div>
      <p>संस्थेचे नाव: <strong>{student.instituteName} </strong></p>

      <h2>विद्यार्थी तपशील</h2>
      <div className="profile-card">
        <img
          src={
            student?.profilePictureUrl
              ? `${API_BASE_URL}${student.profilePictureUrl}`
              : profile
          }
          alt="student"
          className="profile-img"
        />
        <p className="updated-text">{formatDate(student.updatedAt)}</p>
      </div>

      {/* Info Grid */}
      <div className="info-grid">
        <div className="info-box">
          <label>विद्यार्थ्याचे नाव</label>
          <p>{student.studentName}</p>
        </div>

        <div className="info-box">
          <label>इयत्ता</label>
          <p>{student.standardName}</p>
        </div>

        <div className="info-box">
          <label>पालकांचा संपर्क क्रमांक</label>
          <p>{student.parentPhoneNumber}</p>
        </div>

        <div className="info-box">
          <label>पत्ता</label>
          <p>{student.address}</p>
        </div>

        <div className="info-box">
          <label>विद्यार्थी ID</label>
          <p>{student.studentUniqueId}</p>
        </div>

        <div className="info-box">
          <label>ईमेल</label>
          <p>{student.email}</p>
        </div>

        <div className="info-box">
          <label>जन्मतारीख</label>
          <p>{formatDate(student.birthDate)}</p>
        </div>

        <div className="info-box">
          <label>पालकांचे नाव</label>
          <p>{student.parentsName}</p>
        </div>

        {/* <div className="info-box">
          <label>शिक्षक शिक्षण स्तर</label>
          <p>बी. एड / डी. एड</p>
        </div> */}
      </div>

      {/* Exam Table */}
      <div className="exam-section">
        <h2>परीक्षा निकालांचा आढावा</h2>

        <table>
          <thead>
            <tr>
              <th>क्र.</th>
              <th>तारीख</th>
              <th>परीक्षा नाव</th>
              <th>विषय</th>
              <th>एकूण गुण</th>
              <th>मिळालेले गुण</th>
              <th>निकाल</th>
              <th>क्रिया</th>
            </tr>
          </thead>

          <tbody>
            {student?.paperResults?.length > 0 ? (
              student.paperResults.map((r, index) => (
                <tr key={r.studentPaperAttemptId}>
                  <td>{index + 1}</td>
                  <td>
                    {r.submittedDate
                      ? new Date(r.submittedDate).toLocaleDateString("mr-IN")
                      : "-"}
                  </td>
                  <td>{r.paperName}</td>
                  <td>{r.subjectName ?? "-"}</td>
                  <td>{r.totalMarks}</td>
                  <td>{r.obtainedMarks}</td>
                  <td className={r.isPass ? "pass" : "fail"}>
                    {r.isPass ? "पास" : "नापास"}
                  </td>
                  <td><svg xmlns="http://www.w3.org/2000/svg" style={{ cursor: "pointer" }} onClick={() => navigate(`/dashboard/studentresult/${r.studentPaperAttemptId}`)}
                    width="24" height="23" viewBox="0 0 24 23" fill="none">
                    <path d="M12.0056 15.1538C13.0218 15.1538 13.884 14.7981 14.5924 14.0868C15.3007 13.3754 15.6549 12.5117 15.6549 11.4955C15.6549 10.4793 15.2992 9.61708 14.5879 8.90875C13.8765 8.20042 13.0128 7.84625 11.9966 7.84625C10.9805 7.84625 10.1182 8.20192 9.40988 8.91325C8.70154 9.62458 8.34738 10.4883 8.34738 11.5045C8.34738 12.5207 8.70304 13.3829 9.41438 14.0913C10.1257 14.7996 10.9895 15.1538 12.0056 15.1538ZM12.0011 14.2C11.2511 14.2 10.6136 13.9375 10.0886 13.4125C9.56362 12.8875 9.30112 12.25 9.30112 11.5C9.30112 10.75 9.56362 10.1125 10.0886 9.5875C10.6136 9.0625 11.2511 8.8 12.0011 8.8C12.7511 8.8 13.3886 9.0625 13.9136 9.5875C14.4386 10.1125 14.7011 10.75 14.7011 11.5C14.7011 12.25 14.4386 12.8875 13.9136 13.4125C13.3886 13.9375 12.7511 14.2 12.0011 14.2ZM12.0039 18C9.83787 18 7.86387 17.4106 6.08187 16.2317C4.29988 15.0529 2.96529 13.4757 2.07812 11.5C2.96529 9.52433 4.29896 7.94708 6.07912 6.76825C7.85929 5.58942 9.83238 5 11.9984 5C14.1644 5 16.1384 5.58942 17.9204 6.76825C19.7024 7.94708 21.037 9.52433 21.9241 11.5C21.037 13.4757 19.7033 15.0529 17.9231 16.2317C16.143 17.4106 14.1699 18 12.0039 18Z" fill="#313030" />
                  </svg></td>

                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" style={{ textAlign: "center" }}>
                  परीक्षा निकाल उपलब्ध नाही
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StudentView;
